module.exports = __webpack_public_path__ + "static/media/d1.43c50312.png";